export default function useMapEnum(values: (number | string)[]) {
  // values passed in like Object.values(My_Enum) results in ("A", "B", "C", 1, 2, 3)

  const mapped: { label: string, value: number }[] = []

  // Iterate for half the parameter array
  for (let i = 0; i < values.length / 2; i++) {
    // Push key and corresponding value
    mapped.push({ label: values[i] as string, value: Number(values[i + (values.length / 2)]) })
  }

  return mapped;
}
